/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Clovie API
 * Salon management API
 * OpenAPI spec version: 0.0.1
 */
import { useInfiniteQuery, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  GetReportsAppointments200,
  GetReportsAppointmentsParams,
  GetReportsClients200,
  GetReportsClientsParams,
  GetReportsImpact200,
  GetReportsImpactParams,
  GetReportsMarketing200,
  GetReportsMarketingParams,
  GetReportsMissedCalls200,
  GetReportsMissedCallsParams,
  GetReportsOverview200,
  GetReportsOverviewParams,
  GetReportsReviews200,
  GetReportsReviewsParams,
  GetReportsSales200,
  GetReportsSalesParams,
  GetReportsTeam200,
  GetReportsTeamParams,
  GetReportsTodaySummary200,
} from '.././schemas';

import { customInstance } from '../../axios-instance';

/**
 * @summary Missed callers saved by Hayven's text-back (counts; money for admins/agency only, and only where the salon's setup values a visit)
 */
export const getReportsMissedCalls = (
  params?: GetReportsMissedCallsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetReportsMissedCalls200>({
    url: `/reports/missed-calls`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsMissedCallsInfiniteQueryKey = (params?: GetReportsMissedCallsParams) => {
  return ['infinite', `/reports/missed-calls`, ...(params ? [params] : [])] as const;
};

export const getGetReportsMissedCallsQueryKey = (params?: GetReportsMissedCallsParams) => {
  return [`/reports/missed-calls`, ...(params ? [params] : [])] as const;
};

export const getGetReportsMissedCallsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMissedCalls>>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMissedCallsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsMissedCalls>>> = ({ signal }) =>
    getReportsMissedCalls(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsMissedCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsMissedCallsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsMissedCalls>>
>;
export type GetReportsMissedCallsInfiniteQueryError = unknown;

export function useGetReportsMissedCallsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMissedCalls>>>,
  TError = unknown,
>(
  params: undefined | GetReportsMissedCallsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMissedCalls>>,
          TError,
          Awaited<ReturnType<typeof getReportsMissedCalls>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMissedCallsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMissedCalls>>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMissedCalls>>,
          TError,
          Awaited<ReturnType<typeof getReportsMissedCalls>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMissedCallsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMissedCalls>>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Missed callers saved by Hayven's text-back (counts; money for admins/agency only, and only where the salon's setup values a visit)
 */

export function useGetReportsMissedCallsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMissedCalls>>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsMissedCallsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsMissedCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMissedCallsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsMissedCalls>>> = ({ signal }) =>
    getReportsMissedCalls(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsMissedCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsMissedCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsMissedCalls>>
>;
export type GetReportsMissedCallsQueryError = unknown;

export function useGetReportsMissedCalls<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params: undefined | GetReportsMissedCallsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMissedCalls>>,
          TError,
          Awaited<ReturnType<typeof getReportsMissedCalls>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMissedCalls<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMissedCalls>>,
          TError,
          Awaited<ReturnType<typeof getReportsMissedCalls>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMissedCalls<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Missed callers saved by Hayven's text-back (counts; money for admins/agency only, and only where the salon's setup values a visit)
 */

export function useGetReportsMissedCalls<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsMissedCallsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsMissedCallsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMissedCallsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsMissedCalls>>> = ({ signal }) =>
    getReportsMissedCalls(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsMissedCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsMissedCallsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsMissedCalls>>
>;
export type GetReportsMissedCallsSuspenseQueryError = unknown;

export function useGetReportsMissedCallsSuspense<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params: undefined | GetReportsMissedCallsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMissedCallsSuspense<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMissedCallsSuspense<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Missed callers saved by Hayven's text-back (counts; money for admins/agency only, and only where the salon's setup values a visit)
 */

export function useGetReportsMissedCallsSuspense<
  TData = Awaited<ReturnType<typeof getReportsMissedCalls>>,
  TError = unknown,
>(
  params?: GetReportsMissedCallsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMissedCalls>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsMissedCallsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Owner's salon-local Today summary (visits served, walk-in wait, new clients, review texts, no-shows, per-tech turns)
 */
export const getReportsTodaySummary = (signal?: AbortSignal) => {
  return customInstance<GetReportsTodaySummary200>({
    url: `/reports/today-summary`,
    method: 'GET',
    signal,
  });
};

export const getGetReportsTodaySummaryInfiniteQueryKey = () => {
  return ['infinite', `/reports/today-summary`] as const;
};

export const getGetReportsTodaySummaryQueryKey = () => {
  return [`/reports/today-summary`] as const;
};

export const getGetReportsTodaySummaryInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTodaySummary>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsTodaySummaryInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTodaySummary>>> = ({ signal }) =>
    getReportsTodaySummary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsTodaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsTodaySummaryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsTodaySummary>>
>;
export type GetReportsTodaySummaryInfiniteQueryError = unknown;

export function useGetReportsTodaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTodaySummary>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTodaySummary>>,
          TError,
          Awaited<ReturnType<typeof getReportsTodaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTodaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTodaySummary>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTodaySummary>>,
          TError,
          Awaited<ReturnType<typeof getReportsTodaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTodaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTodaySummary>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Owner's salon-local Today summary (visits served, walk-in wait, new clients, review texts, no-shows, per-tech turns)
 */

export function useGetReportsTodaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTodaySummary>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTodaySummaryInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsTodaySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsTodaySummaryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTodaySummary>>> = ({ signal }) =>
    getReportsTodaySummary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsTodaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsTodaySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsTodaySummary>>
>;
export type GetReportsTodaySummaryQueryError = unknown;

export function useGetReportsTodaySummary<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTodaySummary>>,
          TError,
          Awaited<ReturnType<typeof getReportsTodaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTodaySummary<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTodaySummary>>,
          TError,
          Awaited<ReturnType<typeof getReportsTodaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTodaySummary<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Owner's salon-local Today summary (visits served, walk-in wait, new clients, review texts, no-shows, per-tech turns)
 */

export function useGetReportsTodaySummary<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTodaySummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsTodaySummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsTodaySummaryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTodaySummary>>> = ({ signal }) =>
    getReportsTodaySummary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsTodaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsTodaySummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsTodaySummary>>
>;
export type GetReportsTodaySummarySuspenseQueryError = unknown;

export function useGetReportsTodaySummarySuspense<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTodaySummarySuspense<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTodaySummarySuspense<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Owner's salon-local Today summary (visits served, walk-in wait, new clients, review texts, no-shows, per-tech turns)
 */

export function useGetReportsTodaySummarySuspense<
  TData = Awaited<ReturnType<typeof getReportsTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTodaySummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTodaySummarySuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sales page: sales, average ticket, tips, by day / weekday / service type, top services, payments, gift cards, discounts (owner/admin/agency only)
 */
export const getReportsSales = (params?: GetReportsSalesParams, signal?: AbortSignal) => {
  return customInstance<GetReportsSales200>({
    url: `/reports/sales`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsSalesInfiniteQueryKey = (params?: GetReportsSalesParams) => {
  return ['infinite', `/reports/sales`, ...(params ? [params] : [])] as const;
};

export const getGetReportsSalesQueryKey = (params?: GetReportsSalesParams) => {
  return [`/reports/sales`, ...(params ? [params] : [])] as const;
};

export const getGetReportsSalesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsSales>>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsSalesInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsSales>>> = ({ signal }) =>
    getReportsSales(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsSales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsSalesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsSales>>
>;
export type GetReportsSalesInfiniteQueryError = unknown;

export function useGetReportsSalesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsSales>>>,
  TError = unknown,
>(
  params: undefined | GetReportsSalesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSales>>,
          TError,
          Awaited<ReturnType<typeof getReportsSales>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsSalesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsSales>>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSales>>,
          TError,
          Awaited<ReturnType<typeof getReportsSales>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsSalesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsSales>>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sales page: sales, average ticket, tips, by day / weekday / service type, top services, payments, gift cards, discounts (owner/admin/agency only)
 */

export function useGetReportsSalesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsSales>>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsSalesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsSalesQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsSalesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsSales>>> = ({ signal }) =>
    getReportsSales(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsSales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsSalesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsSales>>>;
export type GetReportsSalesQueryError = unknown;

export function useGetReportsSales<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params: undefined | GetReportsSalesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSales>>,
          TError,
          Awaited<ReturnType<typeof getReportsSales>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsSales<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSales>>,
          TError,
          Awaited<ReturnType<typeof getReportsSales>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsSales<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sales page: sales, average ticket, tips, by day / weekday / service type, top services, payments, gift cards, discounts (owner/admin/agency only)
 */

export function useGetReportsSales<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsSalesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsSalesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsSalesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsSales>>> = ({ signal }) =>
    getReportsSales(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsSales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsSalesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsSales>>
>;
export type GetReportsSalesSuspenseQueryError = unknown;

export function useGetReportsSalesSuspense<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params: undefined | GetReportsSalesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsSalesSuspense<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsSalesSuspense<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sales page: sales, average ticket, tips, by day / weekday / service type, top services, payments, gift cards, discounts (owner/admin/agency only)
 */

export function useGetReportsSalesSuspense<
  TData = Awaited<ReturnType<typeof getReportsSales>>,
  TError = unknown,
>(
  params?: GetReportsSalesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsSales>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsSalesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Appointments page: visits, how clients booked, lead time, after-hours bookings, no-shows, cancellations, walk-ins, most booked services
 */
export const getReportsAppointments = (
  params?: GetReportsAppointmentsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetReportsAppointments200>({
    url: `/reports/appointments`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsAppointmentsInfiniteQueryKey = (
  params?: GetReportsAppointmentsParams
) => {
  return ['infinite', `/reports/appointments`, ...(params ? [params] : [])] as const;
};

export const getGetReportsAppointmentsQueryKey = (params?: GetReportsAppointmentsParams) => {
  return [`/reports/appointments`, ...(params ? [params] : [])] as const;
};

export const getGetReportsAppointmentsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsAppointments>>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsAppointmentsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsAppointments>>> = ({ signal }) =>
    getReportsAppointments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsAppointmentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsAppointments>>
>;
export type GetReportsAppointmentsInfiniteQueryError = unknown;

export function useGetReportsAppointmentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsAppointments>>>,
  TError = unknown,
>(
  params: undefined | GetReportsAppointmentsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsAppointments>>,
          TError,
          Awaited<ReturnType<typeof getReportsAppointments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsAppointmentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsAppointments>>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsAppointments>>,
          TError,
          Awaited<ReturnType<typeof getReportsAppointments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsAppointmentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsAppointments>>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Appointments page: visits, how clients booked, lead time, after-hours bookings, no-shows, cancellations, walk-ins, most booked services
 */

export function useGetReportsAppointmentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsAppointments>>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsAppointmentsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsAppointmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsAppointmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsAppointments>>> = ({ signal }) =>
    getReportsAppointments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsAppointmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsAppointments>>
>;
export type GetReportsAppointmentsQueryError = unknown;

export function useGetReportsAppointments<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params: undefined | GetReportsAppointmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsAppointments>>,
          TError,
          Awaited<ReturnType<typeof getReportsAppointments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsAppointments<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsAppointments>>,
          TError,
          Awaited<ReturnType<typeof getReportsAppointments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsAppointments<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Appointments page: visits, how clients booked, lead time, after-hours bookings, no-shows, cancellations, walk-ins, most booked services
 */

export function useGetReportsAppointments<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsAppointmentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsAppointmentsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsAppointmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsAppointments>>> = ({ signal }) =>
    getReportsAppointments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsAppointmentsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsAppointments>>
>;
export type GetReportsAppointmentsSuspenseQueryError = unknown;

export function useGetReportsAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params: undefined | GetReportsAppointmentsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Appointments page: visits, how clients booked, lead time, after-hours bookings, no-shows, cancellations, walk-ins, most booked services
 */

export function useGetReportsAppointmentsSuspense<
  TData = Awaited<ReturnType<typeof getReportsAppointments>>,
  TError = unknown,
>(
  params?: GetReportsAppointmentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsAppointments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsAppointmentsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Team page: each tech side by side — clients, sales, asked for by name, booked again, reviews, chairs filled, turns
 */
export const getReportsTeam = (params?: GetReportsTeamParams, signal?: AbortSignal) => {
  return customInstance<GetReportsTeam200>({ url: `/reports/team`, method: 'GET', params, signal });
};

export const getGetReportsTeamInfiniteQueryKey = (params?: GetReportsTeamParams) => {
  return ['infinite', `/reports/team`, ...(params ? [params] : [])] as const;
};

export const getGetReportsTeamQueryKey = (params?: GetReportsTeamParams) => {
  return [`/reports/team`, ...(params ? [params] : [])] as const;
};

export const getGetReportsTeamInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTeam>>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsTeamInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTeam>>> = ({ signal }) =>
    getReportsTeam(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsTeam>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsTeamInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsTeam>>
>;
export type GetReportsTeamInfiniteQueryError = unknown;

export function useGetReportsTeamInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTeam>>>,
  TError = unknown,
>(
  params: undefined | GetReportsTeamParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTeam>>,
          TError,
          Awaited<ReturnType<typeof getReportsTeam>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTeamInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTeam>>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTeam>>,
          TError,
          Awaited<ReturnType<typeof getReportsTeam>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTeamInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTeam>>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Team page: each tech side by side — clients, sales, asked for by name, booked again, reviews, chairs filled, turns
 */

export function useGetReportsTeamInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsTeam>>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTeamInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsTeamQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsTeamQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTeam>>> = ({ signal }) =>
    getReportsTeam(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsTeam>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsTeam>>>;
export type GetReportsTeamQueryError = unknown;

export function useGetReportsTeam<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params: undefined | GetReportsTeamParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTeam>>,
          TError,
          Awaited<ReturnType<typeof getReportsTeam>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTeam<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTeam>>,
          TError,
          Awaited<ReturnType<typeof getReportsTeam>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTeam<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Team page: each tech side by side — clients, sales, asked for by name, booked again, reviews, chairs filled, turns
 */

export function useGetReportsTeam<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTeamQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsTeamSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsTeamQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTeam>>> = ({ signal }) =>
    getReportsTeam(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsTeam>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsTeamSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsTeam>>
>;
export type GetReportsTeamSuspenseQueryError = unknown;

export function useGetReportsTeamSuspense<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params: undefined | GetReportsTeamParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTeamSuspense<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsTeamSuspense<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Team page: each tech side by side — clients, sales, asked for by name, booked again, reviews, chairs filled, turns
 */

export function useGetReportsTeamSuspense<
  TData = Awaited<ReturnType<typeof getReportsTeam>>,
  TError = unknown,
>(
  params?: GetReportsTeamParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsTeam>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTeamSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Hayven's impact page: visits and money Hayven brought (each visit once), ROI, the work it did and hours saved
 */
export const getReportsImpact = (params?: GetReportsImpactParams, signal?: AbortSignal) => {
  return customInstance<GetReportsImpact200>({
    url: `/reports/impact`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsImpactInfiniteQueryKey = (params?: GetReportsImpactParams) => {
  return ['infinite', `/reports/impact`, ...(params ? [params] : [])] as const;
};

export const getGetReportsImpactQueryKey = (params?: GetReportsImpactParams) => {
  return [`/reports/impact`, ...(params ? [params] : [])] as const;
};

export const getGetReportsImpactInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsImpact>>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsImpactInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsImpact>>> = ({ signal }) =>
    getReportsImpact(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsImpact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsImpactInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsImpact>>
>;
export type GetReportsImpactInfiniteQueryError = unknown;

export function useGetReportsImpactInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsImpact>>>,
  TError = unknown,
>(
  params: undefined | GetReportsImpactParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsImpact>>,
          TError,
          Awaited<ReturnType<typeof getReportsImpact>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsImpactInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsImpact>>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsImpact>>,
          TError,
          Awaited<ReturnType<typeof getReportsImpact>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsImpactInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsImpact>>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hayven's impact page: visits and money Hayven brought (each visit once), ROI, the work it did and hours saved
 */

export function useGetReportsImpactInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsImpact>>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsImpactInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsImpactQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsImpactQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsImpact>>> = ({ signal }) =>
    getReportsImpact(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsImpact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsImpactQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsImpact>>>;
export type GetReportsImpactQueryError = unknown;

export function useGetReportsImpact<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params: undefined | GetReportsImpactParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsImpact>>,
          TError,
          Awaited<ReturnType<typeof getReportsImpact>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsImpact<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsImpact>>,
          TError,
          Awaited<ReturnType<typeof getReportsImpact>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsImpact<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hayven's impact page: visits and money Hayven brought (each visit once), ROI, the work it did and hours saved
 */

export function useGetReportsImpact<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsImpactQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsImpactSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsImpactQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsImpact>>> = ({ signal }) =>
    getReportsImpact(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsImpact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsImpactSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsImpact>>
>;
export type GetReportsImpactSuspenseQueryError = unknown;

export function useGetReportsImpactSuspense<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params: undefined | GetReportsImpactParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsImpactSuspense<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsImpactSuspense<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hayven's impact page: visits and money Hayven brought (each visit once), ROI, the work it did and hours saved
 */

export function useGetReportsImpactSuspense<
  TData = Awaited<ReturnType<typeof getReportsImpact>>,
  TError = unknown,
>(
  params?: GetReportsImpactParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsImpact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsImpactSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Clients page: served, new and returning, who comes back, where new clients came from, overdue regulars and the client list's health
 */
export const getReportsClients = (params?: GetReportsClientsParams, signal?: AbortSignal) => {
  return customInstance<GetReportsClients200>({
    url: `/reports/clients`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsClientsInfiniteQueryKey = (params?: GetReportsClientsParams) => {
  return ['infinite', `/reports/clients`, ...(params ? [params] : [])] as const;
};

export const getGetReportsClientsQueryKey = (params?: GetReportsClientsParams) => {
  return [`/reports/clients`, ...(params ? [params] : [])] as const;
};

export const getGetReportsClientsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsClients>>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsClientsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsClients>>> = ({ signal }) =>
    getReportsClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsClientsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsClients>>
>;
export type GetReportsClientsInfiniteQueryError = unknown;

export function useGetReportsClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsClients>>>,
  TError = unknown,
>(
  params: undefined | GetReportsClientsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsClients>>,
          TError,
          Awaited<ReturnType<typeof getReportsClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsClients>>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsClients>>,
          TError,
          Awaited<ReturnType<typeof getReportsClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsClients>>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Clients page: served, new and returning, who comes back, where new clients came from, overdue regulars and the client list's health
 */

export function useGetReportsClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsClients>>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsClientsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsClients>>> = ({ signal }) =>
    getReportsClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsClients>>
>;
export type GetReportsClientsQueryError = unknown;

export function useGetReportsClients<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params: undefined | GetReportsClientsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsClients>>,
          TError,
          Awaited<ReturnType<typeof getReportsClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsClients<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsClients>>,
          TError,
          Awaited<ReturnType<typeof getReportsClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsClients<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Clients page: served, new and returning, who comes back, where new clients came from, overdue regulars and the client list's health
 */

export function useGetReportsClients<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsClientsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsClientsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsClients>>> = ({ signal }) =>
    getReportsClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsClientsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsClients>>
>;
export type GetReportsClientsSuspenseQueryError = unknown;

export function useGetReportsClientsSuspense<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params: undefined | GetReportsClientsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsClientsSuspense<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsClientsSuspense<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Clients page: served, new and returning, who comes back, where new clients came from, overdue regulars and the client list's health
 */

export function useGetReportsClientsSuspense<
  TData = Awaited<ReturnType<typeof getReportsClients>>,
  TError = unknown,
>(
  params?: GetReportsClientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsClientsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Marketing page: every marketing tool in one view (reached, signed up, came in, earned), new clients by month and what is waiting
 */
export const getReportsMarketing = (params?: GetReportsMarketingParams, signal?: AbortSignal) => {
  return customInstance<GetReportsMarketing200>({
    url: `/reports/marketing`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsMarketingInfiniteQueryKey = (params?: GetReportsMarketingParams) => {
  return ['infinite', `/reports/marketing`, ...(params ? [params] : [])] as const;
};

export const getGetReportsMarketingQueryKey = (params?: GetReportsMarketingParams) => {
  return [`/reports/marketing`, ...(params ? [params] : [])] as const;
};

export const getGetReportsMarketingInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMarketing>>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMarketingInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsMarketing>>> = ({ signal }) =>
    getReportsMarketing(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsMarketing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsMarketingInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsMarketing>>
>;
export type GetReportsMarketingInfiniteQueryError = unknown;

export function useGetReportsMarketingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMarketing>>>,
  TError = unknown,
>(
  params: undefined | GetReportsMarketingParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMarketing>>,
          TError,
          Awaited<ReturnType<typeof getReportsMarketing>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMarketingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMarketing>>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMarketing>>,
          TError,
          Awaited<ReturnType<typeof getReportsMarketing>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMarketingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMarketing>>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Marketing page: every marketing tool in one view (reached, signed up, came in, earned), new clients by month and what is waiting
 */

export function useGetReportsMarketingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsMarketing>>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsMarketingInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsMarketingQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMarketingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsMarketing>>> = ({ signal }) =>
    getReportsMarketing(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsMarketing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsMarketingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsMarketing>>
>;
export type GetReportsMarketingQueryError = unknown;

export function useGetReportsMarketing<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params: undefined | GetReportsMarketingParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMarketing>>,
          TError,
          Awaited<ReturnType<typeof getReportsMarketing>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMarketing<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsMarketing>>,
          TError,
          Awaited<ReturnType<typeof getReportsMarketing>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMarketing<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Marketing page: every marketing tool in one view (reached, signed up, came in, earned), new clients by month and what is waiting
 */

export function useGetReportsMarketing<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsMarketingQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsMarketingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMarketingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsMarketing>>> = ({ signal }) =>
    getReportsMarketing(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsMarketing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsMarketingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsMarketing>>
>;
export type GetReportsMarketingSuspenseQueryError = unknown;

export function useGetReportsMarketingSuspense<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params: undefined | GetReportsMarketingParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMarketingSuspense<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsMarketingSuspense<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Marketing page: every marketing tool in one view (reached, signed up, came in, earned), new clients by month and what is waiting
 */

export function useGetReportsMarketingSuspense<
  TData = Awaited<ReturnType<typeof getReportsMarketing>>,
  TError = unknown,
>(
  params?: GetReportsMarketingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsMarketing>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsMarketingSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Reviews & Google page: rating, new reviews, the review-text funnel, latest reviews, Google profile numbers and Maps ranking
 */
export const getReportsReviews = (params?: GetReportsReviewsParams, signal?: AbortSignal) => {
  return customInstance<GetReportsReviews200>({
    url: `/reports/reviews`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsReviewsInfiniteQueryKey = (params?: GetReportsReviewsParams) => {
  return ['infinite', `/reports/reviews`, ...(params ? [params] : [])] as const;
};

export const getGetReportsReviewsQueryKey = (params?: GetReportsReviewsParams) => {
  return [`/reports/reviews`, ...(params ? [params] : [])] as const;
};

export const getGetReportsReviewsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsReviews>>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsReviewsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsReviews>>> = ({ signal }) =>
    getReportsReviews(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsReviews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsReviewsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsReviews>>
>;
export type GetReportsReviewsInfiniteQueryError = void;

export function useGetReportsReviewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsReviews>>>,
  TError = void,
>(
  params: undefined | GetReportsReviewsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsReviews>>,
          TError,
          Awaited<ReturnType<typeof getReportsReviews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsReviewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsReviews>>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsReviews>>,
          TError,
          Awaited<ReturnType<typeof getReportsReviews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsReviewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsReviews>>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews & Google page: rating, new reviews, the review-text funnel, latest reviews, Google profile numbers and Maps ranking
 */

export function useGetReportsReviewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsReviews>>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsReviewsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsReviewsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsReviews>>> = ({ signal }) =>
    getReportsReviews(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsReviews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsReviewsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsReviews>>
>;
export type GetReportsReviewsQueryError = void;

export function useGetReportsReviews<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params: undefined | GetReportsReviewsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsReviews>>,
          TError,
          Awaited<ReturnType<typeof getReportsReviews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsReviews<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsReviews>>,
          TError,
          Awaited<ReturnType<typeof getReportsReviews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsReviews<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews & Google page: rating, new reviews, the review-text funnel, latest reviews, Google profile numbers and Maps ranking
 */

export function useGetReportsReviews<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsReviewsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsReviewsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsReviewsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsReviews>>> = ({ signal }) =>
    getReportsReviews(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsReviews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsReviewsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsReviews>>
>;
export type GetReportsReviewsSuspenseQueryError = void;

export function useGetReportsReviewsSuspense<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params: undefined | GetReportsReviewsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsReviewsSuspense<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsReviewsSuspense<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews & Google page: rating, new reviews, the review-text funnel, latest reviews, Google profile numbers and Maps ranking
 */

export function useGetReportsReviewsSuspense<
  TData = Awaited<ReturnType<typeof getReportsReviews>>,
  TError = void,
>(
  params?: GetReportsReviewsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsReviews>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsReviewsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Overview page: verdict, key numbers, what Hayven brought, sales so far, the top insights across pages and three summaries
 */
export const getReportsOverview = (params?: GetReportsOverviewParams, signal?: AbortSignal) => {
  return customInstance<GetReportsOverview200>({
    url: `/reports/overview`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReportsOverviewInfiniteQueryKey = (params?: GetReportsOverviewParams) => {
  return ['infinite', `/reports/overview`, ...(params ? [params] : [])] as const;
};

export const getGetReportsOverviewQueryKey = (params?: GetReportsOverviewParams) => {
  return [`/reports/overview`, ...(params ? [params] : [])] as const;
};

export const getGetReportsOverviewInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsOverview>>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsOverviewInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsOverview>>> = ({ signal }) =>
    getReportsOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReportsOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsOverviewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsOverview>>
>;
export type GetReportsOverviewInfiniteQueryError = unknown;

export function useGetReportsOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsOverview>>>,
  TError = unknown,
>(
  params: undefined | GetReportsOverviewParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof getReportsOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsOverview>>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof getReportsOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsOverview>>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Overview page: verdict, key numbers, what Hayven brought, sales so far, the top insights across pages and three summaries
 */

export function useGetReportsOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReportsOverview>>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsOverviewInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsOverview>>> = ({ signal }) =>
    getReportsOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsOverview>>
>;
export type GetReportsOverviewQueryError = unknown;

export function useGetReportsOverview<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params: undefined | GetReportsOverviewParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof getReportsOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsOverview<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof getReportsOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsOverview<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Overview page: verdict, key numbers, what Hayven brought, sales so far, the top insights across pages and three summaries
 */

export function useGetReportsOverview<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReportsOverviewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsOverview>>> = ({ signal }) =>
    getReportsOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReportsOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsOverviewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsOverview>>
>;
export type GetReportsOverviewSuspenseQueryError = unknown;

export function useGetReportsOverviewSuspense<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params: undefined | GetReportsOverviewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsOverviewSuspense<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReportsOverviewSuspense<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Overview page: verdict, key numbers, what Hayven brought, sales so far, the top insights across pages and three summaries
 */

export function useGetReportsOverviewSuspense<
  TData = Awaited<ReturnType<typeof getReportsOverview>>,
  TError = unknown,
>(
  params?: GetReportsOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportsOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsOverviewSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
